export const memberTools_cn = {
  // 通用
  email: '邮箱',
  company_name: '公司名',

  // 黑名单
  blacklist: '黑名单',
  latest_update: '最新更新',
  country_region: '国家/区域',
  no_data: '无数据',
  provide_clues: '提供线索',
  blacklist_company: '黑名单公司',
  blacklist_company_desc:
    'JCtrans为全球物流企业提供服务，并使企业找到信誉良好的值得信赖的合作伙伴。作为全球货代联盟，JCtrans一直在对被认为“信誉受损”的公司实施严格的限制。我们建议，任何会员都不应与JCtrans黑名单上的公司开展业务。',
  complain_desc:
    '如果您能提供帮助，我们将不胜感激。感谢您向JCtrans提供的任何信息以及关心和配合。JCtrans将尽最大努力保护会员的利益，并真诚地搭建平台。',

  // 公示名单
  please_enter_: '请输入',
  banner_applicant: '公示名单',
  banner_applicant_desc:
    '以下名单是最新申请的JCtrans会员，您的投诉/建议我们会认真核实采纳',
  application_date: '公示日期',
  complain: '投诉/建议',
  form_validate: '请填写信息并且我们会认真核实',
  desription: '内容',
  your_name: '姓名',
  submit_res_tips: '我们将会核实信息并尽快回复您',
  risk_list_desc: '竭力帮助您降低合作风险',
  top: '置顶',
  status: '状态',
  bad_debts: '坏账',
  bankrupt: '破产',
  issued_date: '发布日期',
  unpaid_amount: '未付金额',
}

export const memberTools_en = {
  // 通用
  email: 'E-mail',
  company_name: 'Company name',

  // 黑名单
  blacklist: 'Blacklist',
  latest_update: 'Latest Update',
  country_region: 'Country/Region',
  no_data: 'No Data',
  provide_clues: 'Provide Clues',
  blacklist_company: 'Black List Company',
  blacklist_company_desc:
    'JCtrans provides global logistics enterprises with a platform to find trustworthy partners with great reputation. As a global freight forwarding community, JCtrans has been applying stringent restrictions related to companies considered “lost in credibility”. We suggested that no members should conduct any business with any company listed on the JCtrans Blacklist.',
  complain_desc:
    'It will be highly appreciated if you can assist with any information you may have to JCtrans . Thanks for your kindly attention and cooperation in advance. JCtrans will do our best to guard members’ benefits and build a platform with good faith.',

  // 公示名单
  please_enter_: 'Please enter ',
  banner_applicant: 'Applicant List',
  banner_applicant_desc:
    'The following lists are the latest JCtrans membership applicants, we will fully collect complain and exmine it',
  application_date: 'Application date',
  complain: 'Complain',
  form_validate: 'Please write down and we will carefully exmine it',
  desription: 'Desription',
  your_name: 'Your Name',
  submit_res_tips: 'We will check on this information and get back to you soon',
  risk_list_desc: 'Try the best to help you decrease the cooperation risk',
  top: 'sticky on top',
  status: 'Status',
  bad_debts: 'Bad Debts',
  bankrupt: 'Bankrupt',
  issued_date: 'Issued date',
  unpaid_amount: 'Unpaid amount',
}
